import URL from "../constant/URL";
import TYPE from "../constant/TYPE";
import MESSAGE from "../constant/MESSAGE";
import http from "../http/http";
import httpAxios from "../http/httpAxios";
import useAnswer from "../hooks/answeringQuestions/useAnswer";
import { errorMessage } from "../redux/errorState";
import { store } from "../components/provider/ReduxProvider";
import { history } from "../components/provider/WrapInnerRenderer";
import { getUserAgent } from "../utils/utilityEtc";
import { PROP } from "../constant";
import { setAnsweringQuestionsAction } from "../redux/answeringQuestions/answeringQuestions";
import { clearLoadingAction, setLoadingAction } from "../redux/loading";

const { convertAnswer } = useAnswer();

const loadInitialQuestion = async ( payload ) => {
  const { user, learningData, loading  } = store.getState();

  if (!user.info?.learnerId) showErrorMessage();

  const pathname = `${ URL.API.LEARNING.COMMON.I }/language/${ user.info.locale }/member/${ user.info.learnerId }/entry/${ payload.learningType }/stage/${ payload.stageCode }`;
  let search = `?timeZone=${ getUserAgent( 'timeZone' ) }&nationCd=${ getUserAgent( 'countryCode' ) }`;

  if (payload?.learningEntryType) {
    search += `&entyPathCd=${payload.learningEntryType}`
  }

  let response;

  if(payload.resumeYn && payload.resumeYn === 'Y') {
    // 이어하기 O
    response = learningData?.resumeLeanInfo;
  } else {
    // 이어하기 X
    await http.request( {
      retries: 1,
      url : `${ pathname }${ search }`,
      success : ( data ) => {
        response = data;
      },
      error : showErrorMessage
    } );
  }

  return { ...payload, data : response };
  // return {
  //   ...payload,
  //   "data": PROP.ANSWERING_TEST_DATA
  // }

};

const recognizeNotes = async ( payload ) => {

  const { notepad } = store.getState();

  let response;

  await http.request( {
    url : URL.API.SELVAS,
    method : http.METHOD.POST,
    type : http.TYPE.SELVAS,
    retries: 1,
    data : {
      apiKey : '',
      
      maxCandidateCount : 1,
      range : notepad.recognizeRange,
      inks : payload.lines.map( v => ( { x : v.points.map( v => v.x ), y : v.points.map( v => v.y ) } ) )
    },
    success : ( data ) => {
      response = data;
    },
    error : showErrorMessage
  } );

  return response;

};

const checkAnswer = async () => {
  store.dispatch(setLoadingAction({ isShowSpinner: true, spinnerType: '1' }));
  const {
    user,
    answeringQuestions
  } = store.getState();

  const answers = answeringQuestions.data.objctYn === 'Y' ? answeringQuestions.multipleAnswer : convertAnswer(answeringQuestions.answer);

  let response;
  const data = {
    url: URL.API.LEARNING.COMMON.CRANSR.CHECK,
    method: http.METHOD.POST,
    data: {
      langCd: user.info.locale,
      qstCd: answeringQuestions.data.qstCd,
      qstCransr: answers,
    },
  }

  await http.request( {
    retries: 1,
    ...data,
    success : ( data ) => {
      response = data;
    },
    error : (error) => {
      showErrorMessage(error, data);
    }
  } );

  store.dispatch(clearLoadingAction());
  return response;

};

const loadQuestion = async ( payload ) => {
  const {
    user,
    answeringQuestions,
    timeCount
  } = store.getState();

  const answer = convertAnswer( answeringQuestions.answer );

  const getDefaultData = () => {
    return {
      chnCd : user.info.channelCode,
      lrnMbrId : user.info.learnerId,
      lrnEntyScnCd : answeringQuestions.learningType,
      entyPathCd : answeringQuestions.learningEntryType,
      qstCd : answeringQuestions.data.qstCd,
      prgsCd : payload.progressCode,
      lrnTotScond : timeCount.totalAnsweringTime,
      overTmYn : answeringQuestions.timeOverLevel ? 'Y' : 'N'
    };
  };

  const getAnsweringData = () => {
    return {
      langCd : user.info.locale,
      stgCd : answeringQuestions.stageCode,
      qstCransr : answer,
      slvTime : timeCount.answeringTime,
      inputTy : answeringQuestions.inputType.length ? answeringQuestions.inputType.join( ';' ) : TYPE.INPUT.NONE,
      inptTime : timeCount.inputTime,
      corPsbleQstYn : answeringQuestions.data.corPsbleQstYn
    };
  };

  const getConceptCheckData = () => {
    return {
      movieTm : answeringQuestions.conceptCheckRunningTime,
      movieSkipYn : answeringQuestions.isFinishedConceptCheck ? 'N' : 'Y'
    };
  };

  let response;
  let data = {
    ...getDefaultData(),
    ...( TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE === payload.progressCode && getAnsweringData() ),
    ...( answeringQuestions.conceptCheckRunningTime && getConceptCheckData() ),
  }

  // 객관식이면서 틀렸을 때 객관식 보기 문항 저장
  if (answeringQuestions.data.objctYn === 'Y' && !answeringQuestions.isAnswer) {
    data.objctExmpCn = answeringQuestions.objctExmpCn;
  }

  // 객관식이면서 객관신 보기를 선택 했을 때 qstCransr 값 변경
  if (answeringQuestions.data.objctYn === 'Y' && answeringQuestions.multipleAnswer) {
    data.qstCransr = answeringQuestions.multipleAnswer;
  }
  
  await http.request( {
    retries: 1,
    url : URL.API.LEARNING.COMMON.STUDY,
    method : http.METHOD.POST,
    data,
    success : ( data ) => {
      response = data;
    },
    error : showErrorMessage
  } );

  return { data : response };

};

const loadAIDiagnosisQuestion = async ( payload ) => {

  const {
    user,
    answeringQuestions,
    timeCount
  } = store.getState();

  const answer = convertAnswer( answeringQuestions.answer );

  const getDefaultData = () => {
    return {
      langCd : user.info.locale,
      lrnMbrId : user.info.learnerId,
      qstCd : answeringQuestions.data.qstCd,
      prgsCd : payload.progressCode,
      lrnTotScond : timeCount.totalAnsweringTime,
      slvTime : timeCount.answeringTime,
      inputTy : answeringQuestions.inputType?.length ? answeringQuestions.inputType.join( ';' ) : TYPE.INPUT.NONE,
      inptTime : timeCount.inputTime,
      cnAnsrYn : payload.pass ? 'Y' : 'N'
    };
  };

  const getAnsweringData = () => ( { qstCransr : answer } );

  let response;

  let data = {
    ...getDefaultData(),
    ...(TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE === payload.progressCode && getAnsweringData())
  }

  // 객관식이면서 객관신 보기를 선택 했을 때 qstCransr 값 변경
  if (answeringQuestions.data.objctYn === 'Y' && answeringQuestions.multipleAnswer) {
    data.qstCransr = answeringQuestions.multipleAnswer;
  }

  await http.request( {
    url : URL.API.DIAGNOSIS.PROGRESS,
    method : http.METHOD.POST,
    data,
    success : ( data ) => {
      response = data;
    },
    error : showErrorMessage
  } );

  return response;

};

const loadQuestionList = async ( payload ) => {

  const locale = localStorage.getItem( 'locale' );

  let response;

  await http.request( {
    url : `${ URL.API.QSTISP.I }/language/${ locale }/stage/${ payload }/question`,
    success : ( data ) => {
      response = data;
    },
    error : showErrorMessage
  } );

  return response;

};

const checkAnswerForInspection = async () => {

  const { answeringQuestions } = store.getState();

  let response;
  await http.request( {
    url: URL.API.QSTISP.CRANSR.CHECK,
    method: http.METHOD.POST,
    data: {
      langCd: 'KO',
      qstCd: answeringQuestions.data.qstCd,
      qstCransr: convertAnswer(answeringQuestions.answer)
    },
    success : ( data ) => {
      response = data;
    },
    error: showErrorMessage
  } );

  return response;

};

const showErrorMessage = ( error, data ) => {
  if (error?.code !== 20) {
    error.code && store.dispatch(errorMessage(error.code, MESSAGE.UNKNOWN_ERROR, history.goBack));
  }
};

const sendNotesLog = () => {

  

  try {
    const {
    user,
    answeringQuestions,
    notepad,
    logData
  } = store.getState();
  
    const convertedAnswer = convertAnswer(answeringQuestions.answer.map(v => -1 === v.indexOf('\\phantom') ? v : '')).split(';');
    const answer = convertedAnswer.map((v, i) => ({ binary: notepad.data[i], latexCode: v }));

    httpAxios({
      url: URL.API.KINESIS.WRITTEN,
      method: TYPE.HTTP_METHOD.POST,
      data: {
        actor: logData.actor,
        context: {
          extensions: {
            'http://context/extension/notes': {
              channelCode: user.info?.channelCode,
              recognizeRange: notepad?.recognizeRange,
              answer
            }
          }
        }
      },
      timeout: 10000
    });
  } catch (error) {
    console.log("###### sendNotesLog: ", error);
  }

};

export {
  loadInitialQuestion,
  recognizeNotes,
  checkAnswer,
  loadQuestion,
  loadAIDiagnosisQuestion,
  loadQuestionList,
  checkAnswerForInspection,
  sendNotesLog
};
